import styles from './Avatar.module.css';
import { useProfileAvatarUrl } from '~/hooks/profile/useProfileAvatarUrl';
import {useProfileFullName} from "~/hooks/profile/useProfileFullName";

interface AvatarProps {
  className?: string;
}

export function Avatar({ className }: AvatarProps) {
    const avatarUrl = useProfileAvatarUrl();
    const fullName = useProfileFullName() || "User";

    return avatarUrl ? (
        <div className={`${styles.avatar} ${className || ''}`}>
            <img
                src={avatarUrl}
                alt={`${fullName} avatar`}
                width={32}
                height={32}
                className={styles.avatarImage}
            />
        </div>
  ): null;
}
